export default "__VITE_ASSET__DRXC60u0__"